import React from "react";
import type { ImageProps } from "@chakra-ui/react";
import { Image } from "@chakra-ui/react";

import type { Maybe, VisualBynderType } from "@shared/graphql.types";
import { getStaticFile } from "utils/getStaticFile";

type Props = ImageProps & {
  asset?: Maybe<VisualBynderType>;
  priority?: boolean;
};

export const BynderImage: React.FC<Props> = ({
  asset,
  priority,
  ...otherProps
}) => {
  return (
    <Image
      fallbackSrc={
        priority ? undefined : getStaticFile("/images/placeholder.svg")
      }
      {...(asset && {
        srcSet: `${asset.thumbnails?.size_375} 375w, ${asset.thumbnails?.size_460} 460w, ${asset.thumbnails?.size_4_5_web} 768w, ${asset.thumbnails?.size_16_9_web} 1280w`,
        src: `${asset.thumbnails?.size_16_9_web}`,
        alt: asset.description ?? ""
      })}
      {...otherProps}
    />
  );
};
